
export default {
  namespaced: true,
  state: {
    palette: {},
    theme: '',
    splashScreen: '',
    splashScreenMobile: '',
    appBarImageMobile: ''
  },
  getters: {
    getTheme: (state, getters) => {
      return state.theme
    },
    getSplashScreen: (state, getters) => {
      return state.splashScreen
    },
    getSplashScreenMobile: (state, getters) => {
      return state.splashScreenMobile
    },
    getAppBarImgMobile: (state, getters) => {
      return state.appBarImageMobile
    },
    getPalette: (state, getters) => {
      return state.palette
    }
  },
  mutations: {
    setPalette (state, paletteSelected) {
      state.palette = require(`@/theme/${paletteSelected}/colors/theme.scss`)
    },
    setTheme (state, themeSelected) {
      state.theme = themeSelected
    },
    setImages (state, themeSelected) {
      state.splashScreen = require(`@/theme/${themeSelected}/images/splashLogo.png`)
      state.splashScreenMobile = require(`@/theme/${themeSelected}/images/mobile/SplashScreen/splashLogo.png`)
      state.appBarImageMobile = require(`@/theme/${themeSelected}/images/mobile/AppBar/appBarLogo.png`)
    }
  },
  actions: {
    changeTheme ({ dispatch, commit, getters, rootGetters }, themeSelected) {
      const theme = themeSelected ?? rootGetters['configurationStore/theme']
      commit('setTheme', theme)
      commit('setPalette', theme)
      commit('setImages', theme)
    }
  }
}
